// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluationPage-cls1_fwa","cls2":"EvaluationPage-cls2_MhC EvaluationPage-cls1_fwa"};